import React, { useState, useRef } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { Link,NavLink} from 'react-router-dom';
import { SidebarData } from './navigation/NavigationData';
import { SidebarDataClient } from './navigation/NavigationDataClient';
import { SidebarLetter } from './navigation/NavigationLetter';
import { SidebarStaff } from './navigation/NavigationStaff';
import './navigation/Navigation.css';
import { IconContext } from 'react-icons';
import Grid from "@material-ui/core/Grid";
function Navigation() {
    const sidebar = useRef(0);
    const showSidebar = () => {
        if (sidebar.current.className =="nav-menu active"){
            sidebar.current.className = "nav-menu"
        }else{
            sidebar.current.className = "nav-menu active"
        }
    };

    return (
        <>
            <IconContext.Provider value={{ color: '#fff' }}>
                <Grid item xs={9}>
                <div className='navbar' style={{ backgroundColor: "#fff", color: '#007efa' }}>
                    <Link to='#' className='menu-bars'>
                           <FaIcons.FaBars onClick={showSidebar} style={{ backgroundColor: "#fff", color: '#007efa' }} />
                               
                    </Link>
                </div>
                </Grid>
                <nav className='nav-menu' ref={sidebar}>
                    <ul className='nav-menu-items' >
                        {sessionStorage.getItem('role-users-id') != null && [1].includes(parseInt(sessionStorage.getItem('role-users-id'))) && SidebarData.map((item, index) => {
                            return (
                                <li key={index} className={item.cName} onClick={showSidebar}>
                                    <NavLink to={item.path} activeClassName="active">
                                        {item.icon}
                                        <span>{item.title}</span>
                                    </NavLink>
                                </li>
                            );
                        })}
                        {sessionStorage.getItem('role-users-id') != null && [10].includes(parseInt(sessionStorage.getItem('role-users-id'))) && SidebarLetter.map((item, index) => {
                            return (
                                <li key={index} className={item.cName} onClick={showSidebar}>
                                    <NavLink to={item.path} activeClassName="active">
                                        {item.icon}
                                        <span>{item.title}</span>
                                    </NavLink>
                                </li>
                            );
                        })}
                        {sessionStorage.getItem('role-users-id') != null && ![3,4,1,10].includes(parseInt(sessionStorage.getItem('role-users-id'))) && SidebarStaff.map((item, index) => {
                            return (
                                <li key={index} className={item.cName} onClick={showSidebar}>
                                    <NavLink to={item.path} activeClassName="active">
                                        {item.icon}
                                        <span>{item.title}</span>
                                    </NavLink>
                                </li>
                            );
                        })}
                        {sessionStorage.getItem('role-users-id') != null && [3, 4].includes(parseInt(sessionStorage.getItem('role-users-id'))) && SidebarDataClient.map((item, index) => {
                            return (
                                <li key={index} className={item.cName} onClick={showSidebar}>
                                    <NavLink to={item.path} activeClassName="active">
                                        {item.icon}
                                        <span>{item.title}</span>
                                    </NavLink>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </IconContext.Provider>
        </>
    );
}

export default Navigation;